var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { object, string } from "decoders";
import StatusCode from "status-code-enum";
class BaseError extends Error {
    constructor(message) {
        super(message);
        this.name = "BaseError";
    }
}
class APIError extends BaseError {
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = "APIError";
    }
}
export class InternalServerError extends APIError {
    constructor(message) {
        super(StatusCode.ServerErrorInternal, message);
        this.name = "InternalServerError";
    }
}
export class NotFoundError extends APIError {
    constructor(message) {
        super(StatusCode.ClientErrorNotFound, message);
        this.name = "NotFoundError";
    }
}
export class UnauthorizedError extends APIError {
    constructor(message) {
        super(StatusCode.ClientErrorUnauthorized, message);
        this.name = "UnauthorizedError";
    }
}
const errorResponseDecoder = object({
    message: string,
});
export const throwAPIError = (response) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const responseJson = yield response.json();
    const { message } = (_a = errorResponseDecoder.value(responseJson)) !== null && _a !== void 0 ? _a : {
        message: "An error occurred.",
    };
    switch (response.status) {
        case StatusCode.ClientErrorNotFound: {
            throw new NotFoundError(message);
        }
        case StatusCode.ClientErrorUnauthorized: {
            throw new UnauthorizedError(message);
        }
        case StatusCode.ServerErrorInternal: {
            throw new InternalServerError(message);
        }
        default: {
            throw new APIError(response.status, message);
        }
    }
});
